import { useEffect, useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { Loading } from '../../components/Loading';
import { urlHelper } from '../../helpers/urlHelper';
import { visaRedirect } from '../../store/action_creators/payments.actions';
import { AppActions } from './../../store/config/ActionTypes';
import { RootState } from './../../store/config/types';

const mapStateToProps = (state: RootState) => ({
  payments: state.payments,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  visaRedirected: (paymentId: string) => dispatch(visaRedirect(paymentId)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export function Redirect({ payments, visaRedirected }: PropsFromRedux) {
  const navigate = useNavigate();
  const isOnIframe = window.location !== window.parent.location;
  const urlVars = urlHelper.parseQueryString();
  const beginPaymentId = urlVars.beginPaymentId || '';
  const redirectErrorCode = urlVars.errorcode || urlVars.errormessage || '';
  const redirectRequested = useRef(false);

  useEffect(() => {
    //Visa and Sistarbank redirect should reopen SignalR connection
    if (!isOnIframe && beginPaymentId && !redirectRequested.current) {
      // A ref is used because Redux dispatches synchronously and can trigger a
      // render before a state-based guard has been committed.
      redirectRequested.current = true;
      visaRedirected(beginPaymentId);
    }
  }, [beginPaymentId, isOnIframe, visaRedirected]);

  useEffect(() => {
    if (isOnIframe) {
      const message = {
        message: redirectErrorCode ? 'redirectError' : 'redirectSuccess',
        payload: redirectErrorCode || beginPaymentId,
      };

      window.parent.postMessage(message, window.location.origin);
    }
  }, [beginPaymentId, isOnIframe, redirectErrorCode]);

  useEffect(() => {
    if (isOnIframe) {
      return;
    }

    const query = new URLSearchParams();
    if (beginPaymentId) {
      query.set('beginPaymentId', beginPaymentId);
    }

    if (redirectErrorCode) {
      query.set('errorCode', redirectErrorCode);
      navigate(`/result?${query.toString()}`, { replace: true });
    } else if (payments.transactionCallbackReceived) {
      navigate(`/result?${query.toString()}`, { replace: true });
    }
  }, [
    beginPaymentId,
    isOnIframe,
    navigate,
    payments.transactionCallbackReceived,
    redirectErrorCode,
  ]);

  return <Loading />;
}

export default connector(Redirect);
